<template>
  <a-select :class="klass" @change="onChange" :value="value"
    showSearch
    @search="onSearch"
    :dropdownMatchSelectWidth="false"
    :filterOption="false"
    :mode="mode" :getPopupContainer="triggerNode => triggerNode.parentNode"
    :placeholder="placeholder" :disabled="disabled">
    <a-select-option v-for="item in list" :key="item.key" :value="item.value">
      {{item.label}}
    </a-select-option>

  </a-select>

</template>

<script>
  import eBase from '@/base/eBase.js';
  import _ from 'underscore';

  export default {

    props: {
      url: {
        required: true
      },
      options: {
        required: true
      },
      method: {
        required: false,
        default: 'get'
      },
      klass: {
        required: false,
        default: 'full-input'
      },
      placeholder: {
        required: false,
        default: '请选择'
      },
      value: {
        required: false,
        default () {
          return [];
        }
      },
      disabled: {
        required: false,
        default: false
      },
      emptyValue: {
        required: false,
        default: '小区'
      },
      selectFirst: {
        required: false,
        default: false
      },
      mode: {
        required: false,
        default: 'default'
      },
    },

    data() {
      return {
        list: [],
      };
    },

    created() {
      eBase.debug('[DynamicSelect.vue][created][enter]');
      this.init();
    },

    mounted() {
      eBase.debug('[DynamicSelect.vue][mounted][enter]');
    },

    watch: {
      options: {
        handler(newValue, oldValue) {
          if (JSON.stringify(newValue) != JSON.stringify(oldValue)) {
            this.search();
          }
        },
        immediate: false,
      },
      value: {
        handler(newValue, oldValue) {},
        immediated: false,
      },
    },

    computed: {},

    methods: {

      init() {
        this.search();
      },

      search(value) {
        const self = this;
        eBase.send({
          url: this.url+value,
          params: this.options
        }, this.method).then((res) => {
          self.list = this.getComputerList(res);
          const selectValue = self.list.filter((one) => {
            return one.selected == 'true'
          })[0];
          self.list.length > 0 && selectValue && self.$emit('onSelected', selectValue);
          self.list.length > 0 && self.selectFirst && self.$emit('onSelectFirst', [self.list[0].key]);
          self.list.length > 0 && self.selectFirst && self.$emit('onFullSelectFirst', this.getItemByValue([self.list[
            0].key]));
          self.$emit('selectRenderComplete', self.list);
        }, (res) => {
          self.list = [];
          self.$emit('selectRenderComplete', self.list);
          eBase.debug('[DynamicSelect.vue][search][erro]' + JSON.stringify(res));
        });
      },

      onChange(value) {
        this.$emit('change', this.getItemByValue(value).name);
        this.$emit('fullChange', this.getItemByValue(value));
      },

      getItemByValue(value) {
        let result = {};
        _.each(this.list, (item) => {
          if (item.key == value) {
            result = _.clone(item);
          }
        });

        return result;
      },

      getComputerList(res) {
        const result = [];

        let arrTem = res.data.list || res.data.data.list || res.data.data;

        // let objTem = {
        //   "code": "",
        //   "name": "全部",
        //   "parent_code": null,
        //   "type": null
        // };

        // arrTem.unshift(objTem);

        // const arr = arrTem;

        _.each(arrTem, (item) => {
          let one = _.clone(item);

          if (_.has(item, 'value')) {
            one.key = item.value + '';
            one.value = item.value + '';
          }

          if (_.has(item, 'code')) {
            one.key = item.code + '';
            one.value = item.code + '';
          }

          if (_.has(item, 'label')) {
            one.label = item.label + '';
          }

          if (_.has(item, 'name')) {
            one.label = item.name + '';
          }

          if (_.has(item, 'title')) {
            one.label = item.title + '';
          }

          if (_.has(item, 'id')) {
            one.key = item.id + '';
            one.value = item.id + '';
          }

          result.push(one);

        });
        return result;
      },

      onSearch(value){
        this.search(value);
      }

    }, // EOF methods
  };
</script>



// WEBPACK FOOTER //
// src/components/select/DynamicSelectSearch.vue